import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelectLanguage } from '../../hooks/global/Languages';

export default function Radio({ value, question, onChange, sourceId }) {
  const { t, i18n } = useTranslation();
  const lng = i18n.language.toUpperCase();

  const { selectTextByLanguage } = useSelectLanguage();

  const handleChange = (score) => {
    score.order = question.order;
    onChange?.(question, score);
    value = score;
  }

  return (
    <div className="reviewInvite-customRadio reviewInvite-customRadioGeneral">
      <div className="reviewInvite-question clearfix">
        <h3>{question.text[lng]}</h3>
        {question.answer.map((item, index) => {
          let id = question.id + "-" + sourceId + "-" + item.value;
          return (
            <div key={id}>
              <input
                type="radio"
                name={question.id}
                id={id}
                onChange={() => handleChange(item)}
                //checked={value === item.value} // Set the checked attribute based on the selected value
                value={item.value}
              />
              <label htmlFor={id}>{selectTextByLanguage(item.text, lng)}</label>
            </div>
          );
        })}
      </div>
    </div>
  )
}
